import { useState, useEffect } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { baseURL } from '../../../services/apiClient';

// Utility function to process image URLs
const processImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  
  // If it's already an absolute URL (starts with http:// or https://), return as is
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }
  
  // If it's a relative URL, prepend the base URL
  // Get the base domain from the API URL (remove /api/v1)
  const apiBaseUrl = baseURL.replace("/api/v1", "").replace(/\/$/, ""); // Remove /api/v1 and trailing slash
  
  // If imageUrl starts with "/", it's an absolute path from domain root
  if (imageUrl.startsWith("/")) {
    return `${apiBaseUrl}${imageUrl}`;
  }
  
  // Otherwise, it's a relative path
  return `${apiBaseUrl}/${imageUrl}`;
};

const DocCard = ({ doc }) => {
  const [imageError, setImageError] = useState(false);
  const [processedImageUrl, setProcessedImageUrl] = useState(null);

  useEffect(() => {
    if (doc?.image_url) {
      const processed = processImageUrl(doc.image_url);
      setProcessedImageUrl(processed);
      setImageError(false);
    } else {
      setImageError(true);
    }
  }, [doc?.image_url]);

  const defaultImageUrl = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23e0e0e0' width='200' height='200'/%3E%3Ctext fill='%23999' font-family='sans-serif' font-size='14' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EDocument%3C/text%3E%3C/svg%3E";

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        backgroundColor: '#ffffff',
        border: "1px solid rgba(227, 227, 227, 1)",
        borderRadius: '15px',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        maxWidth: '250px',
        textWrap: "wrap",
        mx: "auto"
      }}
      onClick={() => window.open(`/doc-view/${doc.docs_id || "1"}`, '_blank')}
    >
      <img
        src={imageError || !processedImageUrl ? defaultImageUrl : processedImageUrl}
        alt="Document Thumbnail"
        onError={() => setImageError(true)}
        style={{ width: '100%', height: 'auto', marginBottom: '15px', borderRadius: '10px' }}
      />
      <Typography variant="body1" sx={{
        fontWeight: 'bold',
        marginBottom: '5px',
        textAlign: 'left',
        color: "black",
        wordWrap: 'break-word',
        wordBreak: 'break-all',
        whiteSpace: 'normal'
      }}>
        {doc.docs}
      </Typography>
      <Typography variant="caption" color="textSecondary" sx={{ textAlign: 'left', marginBottom: '10px', textWrap: "wrap" }}>
        {doc.description}
      </Typography>
    </Box>
  );
};

export default DocCard;
